import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';
import type { PostSearchType } from '#/modules/postSearch/types/PostSearchType';
import type { SearchType } from '#/modules/search/types/SearchType';

type Args = {
  content: CmsApiDocument;
};

export function getCmsApiDocumentDefaultSearchOrPostSearchType({
  content,
}: Args): SearchType | PostSearchType {
  return (
    content.heroSearch?.defaultSearchFilters?.type ??
    content.subsite.defaultSearchType ??
    'JOB'
  );
}
